import SubmitResult from './SubmitResult';
import type { BlogArticle } from './_types';

export interface PopupDefaultProps {
  configKey?: string;
  onClose: () => void;
  articles?: BlogArticle[];
  className?: string;
}

export default function PopupDefault({ configKey, onClose, articles = [], className }: PopupDefaultProps) {
  return (
    <SubmitResult
      type="popup"
      configKey={configKey}
      onClose={onClose}
      articles={articles}
      className={className}
    />
  );
}
